const authRoutes = {
  LOGIN: '/login',
  MFA_CHALLENGE: '/login/mfa',
  MFA_FORCED_ENROLLMENT: '/login/mfa/enroll',
  MFA_RESET: '/reset-mfa',
} as const;

export default authRoutes;
